<template>
<div>
  <b-navbar variant="light" class="mb-4" fixed="top" id="top-menu">
    <b-navbar-nav>
      <label id="help-label">
        <input type="checkbox" class="openSidebarMenu" id="openSidebarMenu" v-model="state.helpMenuOpened" />
        <label for="openSidebarMenu" class="sidebarIconToggle">
          <div class="sidebarSpinner diagonal part-1"></div>
          <div class="sidebarSpinner horizontal"></div>
          <div class="sidebarSpinner diagonal part-2"></div>
        </label>
        Help
      </label>
    </b-navbar-nav>
    <b-navbar-nav class="ml-auto">
      <b-nav-item-dropdown right id="samp-menu">
        <template slot="button-content">
          <font-awesome-icon icon="broadcast-tower" id="samp-signal-icon" v-bind:class="{ hubRunning: samp.hubRunning }" title="SAMP" />
        </template>
        <b-dropdown-item v-if="!samp.hubRunning">
          No SAMP hub found
        </b-dropdown-item>
        <b-dropdown-item v-on:click="registerSamp()" v-if="samp.hubRunning && !samp.registered && samp.clients.length === 0" href="#">
          <font-awesome-icon icon="exchange-alt" />
          Register
        </b-dropdown-item>
        <b-dropdown-item v-for="client in samp.clients" class="samp-client-item" v-bind:key="client.id" href="#" v-on:click="setSampDestination(client.id)" v-bind:class="{ selected: client.selected, sampNoIcon: !client.icon }">
          <img :src="client.icon" v-if="client.icon" />
          {{client.name}}
        </b-dropdown-item>
      </b-nav-item-dropdown>
      <b-nav-item-dropdown right id="files-menu" @shown="clearNotifications">
        <template slot="button-content">
          <b-spinner small v-if="filesPanel.initialLoading || filesPanel.jobRunning"></b-spinner>
          Your files
          <b-badge v-if="!filesPanel.initialLoading" :variant="badgeVariant">{{filesPanel.totalFiles}}</b-badge>
        </template>
        <b-dropdown-group>
          <div>
            <b-list-group>
              <b-list-group-item v-if="filesPanel.notifications.length === 0">
                No files
              </b-list-group-item>
              <b-list-group-item v-for="(item, index) in filesPanel.notifications" v-bind:key="index" :variant="item.type === 'ERROR' ? 'danger' : ''">
                <div class="clearfix">
                  <a href="#" @click.prevent="deleteNotification(item.id)" class="text-danger">
                    <font-awesome-icon icon="times" />
                  </a>
                  &nbsp;
                  <span v-if="item.type === 'ERROR'">{{item.label}}</span>
                  <a :href="item.url" :download="item.label" target="_blank" v-if="item.type !== 'ERROR'">
                    {{item.label}}
                  </a>
                  <a href="#" v-on:click.prevent="sendBySamp(item)" :class="{ active: samp.hubRunning && item.type !== 'ERROR' && item.label.endsWith('.xml')}" class="send-by-samp-btn" title="Send by SAMP">
                    <span class="icon-broadcast"></span>
                  </a>
                </div>
                <small class="text-muted float-right">{{item.createdAt}}</small>
              </b-list-group-item>
              <b-list-group-item v-if="filesPanel.totalItems > 5">
                <b-pagination v-model="filesPanel.currentPage" :total-rows="filesPanel.totalItems" :per-page="5" aria-controls="groups-list" align="center" v-on:change="changeFilePanelPage"></b-pagination>
              </b-list-group-item>
            </b-list-group>
            <b-list-group-item v-if="!filesPanel.initialLoading && filesPanel.freeSpace !== null">
              Free space: {{filesPanel.freeSpace}}
            </b-list-group-item>
          </div>
          <div id="files-loading" v-show="filesPanel.loading">
            <div class="spinner-wrapper">
              <b-spinner variant="primary"></b-spinner>
            </div>
          </div>
        </b-dropdown-group>
      </b-nav-item-dropdown>
    </b-navbar-nav>
    <b-navbar-nav v-if="showLoginButton">
      <b-nav-item href="login">Login</b-nav-item>
    </b-navbar-nav>
    <b-navbar-nav v-if="userLabel !== null">
      <b-nav-item-dropdown right :text="userLabel">
        <b-dropdown-group>
          <div v-if="groups !== null && groups.length > 0">
            <span class="ml-3">Groups:</span>
            <ul>
              <li v-for="group in groups" v-bind:key="group">{{group}}</li>
            </ul>
          </div>
          <div v-if="groups === null || groups.length === 0">
            <p class="text-center">You are in no groups</p>
          </div>
        </b-dropdown-group>
      </b-nav-item-dropdown>
    </b-navbar-nav>
    <b-navbar-nav v-if="showLogoutButton">
      <b-nav-item href="portal-logout">Logout</b-nav-item>
    </b-navbar-nav>
  </b-navbar>
</div>
</template>

<script>
import {
  mapState
} from 'vuex';

export default {
  name: 'TopMenu',
  computed: mapState({
    state: state => state,
    showLoginButton: state => state.showLoginButton,
    showLogoutButton: state => state.showLogoutButton,
    userLabel: state => state.userLabel,
    groups: state => state.groups,
    filesPanel: state => state.filesPanel,
    samp: state => state.samp,
    badgeVariant: state => {
      if (state.filesPanel.successToNotify.length > 0) {
        return 'primary';
      }
      if (state.filesPanel.errorToNotify.length > 0) {
        return 'danger';
      }
    }
  }),
  created() {
    this.$store.dispatch('loadFilesPanel', 1);
  },
  mounted() {
    let self = this;
    window.addEventListener('storage', function() {
      self.$store.dispatch('storageEvent');
    });
  },
  methods: {
    deleteNotification(id) {
      this.$store.dispatch("deleteNotification", id);
    },
    changeFilePanelPage(page) {
      this.$store.dispatch('loadFilesPanel', page);
    },
    clearNotifications() {
      let self = this;
      document.querySelectorAll('.toast').forEach(el => {
        self.$bvToast.hide(el.id);
      });
      this.$store.dispatch('clearNotifications');
    },
    setSampDestination(clientId) {
      this.$store.dispatch('samp/setSampDestination', clientId);
    },
    registerSamp() {
      this.$store.commit('samp/registerSamp');
    },
    sendBySamp(item) {
      this.$store.commit('samp/sendFileBySamp', {
        url: item.url, free: false,
        mtype: 'table.load.votable'
      });
    }
  }
}
</script>

<style>
#files-menu .dropdown-menu,
#samp-menu .dropdown-menu {
  min-width: 310px;
  max-width: 400px;
  z-index: 2000;
}

#files-loading {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 1000;
}

#samp-signal-icon {
  color: #A9A9A9;
}

#samp-signal-icon.hubRunning {
  color: #439e28;
}

.samp-client-item img {
  width: 24px;
  height: 24px;
  margin-right: 15px;
}

.samp-client-item.sampNoIcon a {
  padding-left: 70px;
}

.samp-client-item.selected a {
  font-weight: bold;
}

a.list-group-item {
  color: rgb(33, 37, 41);
}

a.list-group-item:hover {
  text-decoration: none;
}

.send-by-samp-btn {
  margin-left: 8px;
}
</style>
